/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Menu, MenuItem, Box, Typography } from '@mui/material';
import ProfilePic from '../../../../../../components/Common/ProfilePic';

interface iPerson {
  userId: string;
  name: string;
}

interface iRole {
  role: string;
  companyName: string;
  industryTypes: string[];
}

interface Feed {
	taggedPeople?: iPerson[];
	userData?: iRole;
}

interface MenuComponentProps {
  feed?: Feed;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const MentionMenu: React.FC<MenuComponentProps> = ({ feed, anchorEl, onClose }) =>
{
	const open = Boolean(anchorEl);

	return (
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			PaperProps={{
				style : {
					maxHeight : 200,
					width     : '250px'
				}
			}}
		>
			{feed?.taggedPeople?.map((person) => (
				<MenuItem key={person.userId} onClick={onClose}>
					<Box display='inline-flex' sx={{ marginRight: 'var(--pixel16)' }} alignItems='center' justifyContent='center' width={32} height={32}>
						<ProfilePic
							imagePath={`${person?.userId}.jpeg`}
							defaultImg={'/images/icons/defaultUser.svg'}
							alt='createdBy'
							className='brdrRadius50'
							width='none'
							height='none'
							from='selfProfile'
						/>
					</Box>
					<Typography sx={{ textTransform: 'capitalize' }}>{person?.name}</Typography>
				</MenuItem>
			))}
		</Menu>
	);
};

export default MentionMenu;